import { render } from "./ReviseReport.vue?vue&type=template&id=0d90cc33&scoped=true"
import script from "./ReviseReport.vue?vue&type=script&lang=js"
export * from "./ReviseReport.vue?vue&type=script&lang=js"

import "./ReviseReport.vue?vue&type=style&index=0&id=0d90cc33&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d90cc33"]])

export default __exports__